export enum Breakpoints {
  maxMobile = 480,
  largeMobile = 540,
  minTablet = Breakpoints.maxMobile,
  maxTablet = 768,
  minLaptop = Breakpoints.maxTablet,
  maxLaptop = 1024,
  minDesktop = Breakpoints.maxLaptop,
  maxDesktop = 1440,
  minWide = Breakpoints.maxDesktop,
  maxWide = 1920,
  minUltraWide = Breakpoints.maxWide,
}
